import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import {defaultToolbar} from "../../form/editor/editor";
import TemplateEditor from "../../form/editor/TemplateEditor";
import DateTimeInput from "../../form/DateTimeInput";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";
import {EmailTemplateButton} from "../../form/editor/plugins/EmailTemplate";
import {PreHeader} from "../../form/editor/plugins/PreHeader";
import {ColorTransform} from "../../form/editor/plugins/ColorTransform";
import MjmlField from "../../form/mjml/MjmlField";
import ContentLoader from "../../layout/ContentLoader";
import Collapse from "../../layout/Collapse";
import {loadComponentById} from "../../../utils/components";
import Button from "../../form/Button";
import QueryBuilder from "./NewsLetter/QueryBuilder/QueryBuilder";
import removeEmpty from "./NewsLetter/QueryBuilder/removeEmpty";

class NewsletterStat extends React.Component {

    state = {
        values: {},
        opened: false,
        isLoading: false
    }

    constructor(props) {
        super(props);
        this.componentDidUpdate({}, props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component_id !== prevProps.component_id || this.state.opened !== prevState.opened) {
            this.loadStat();
        }
    }

    loadStat = () => {
        this.setState({isLoading: true}, () => {
            if (this.state.opened) {
                loadComponentById(this.props.component, this.props.component_id, ["unique_opens", "opens"]).then((values) => {
                    this.setState({
                        isLoading: false,
                        values
                    })
                });
            } else {
                this.setState({
                    isLoading: false,
                    values: {}
                })
            }
        });
    }

    render() {
        if (!this.props.component_id) return null;
        return <div className="row">
                <div className="col-md-12">
                    <Button block={true} color="default" onClick={() => this.setState({opened: !this.state.opened})}>
                        Statisztika <span className="caret"/>
                    </Button>
                </div>
                <Collapse collapsed={this.state.opened}>
                    <div className="col-md-12">
                        {this.state.isLoading ? <ContentLoader /> : <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    name="unique_opens"
                                    value={this.state.values.unique_opens || 0}
                                    label="Nyitások"
                                    formatter={UnitFormatter}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("unique_opens")}
                                    disabled="disabled"
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    name="opens"
                                    value={this.state.values.opens || 0}
                                    label="Nyitások (összesen)"
                                    formatter={UnitFormatter}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("opens")}
                                    disabled="disabled"
                                />
                            </div>
                        </div>}
                    </div>
                </Collapse>
            </div>
        ;
    }
}

class NewsletterForm extends React.Component {

    state = {
        template: null,
        isLoading: 0,
    };

    render() {
        const disabled = this.props.disabled;
        const toolbar = [
            ...defaultToolbar,
            (props) => <EmailTemplateButton
                key={props.key}
                saveChanges={(template) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("html", template); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
                saveTemplateEngine={(template_engine) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("template_engine", template_engine); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
                saveReplacementEngine={(replacement_engine) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("replacement_engine", replacement_engine); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
            />,
            (props) => <PreHeader key={props.key} value={this.props.values.html} saveChanges={(value) => this.props.setFieldValue("html", value)} />,
            //(props) => <ColorTransform key={props.key} value={this.props.values.html} saveChanges={(value) => this.props.setFieldValue("html", value)} />
        ];
        const recipient_params = ((typeof this.props.values.recipient_params === "string" ? JSON.parse(this.props.values.recipient_params) : this.props.values.recipient_params) || {});
        const paramsProps = {
            name: "recipient_params",
            value: recipient_params.filter,
            saveChanges: (field, value) => {
                const v = ((typeof this.props.values.recipient_params === "string" ? JSON.parse(this.props.values.recipient_params) : this.props.values.recipient_params) || {});
                v.filter = value;
                if (!removeEmpty(value)) {
                    delete v.filter;
                }
                if (Object.keys(v).length) {
                    this.props.setFieldValue(field, v);
                } else {
                    if (this.props.values[this.props.componentConfig.idfield] && this.props.values[field] !== null) {
                        this.props.setFieldValue(field, null);
                    } else if (!this.props.values[this.props.componentConfig.idfield] && this.props.values[field] !== undefined) {
                        this.props.setFieldValue(field, undefined);
                    }
                }
            }
        };
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-1 col-sm-push-11">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-11 col-sm-pull-1">
                        <TextInput
                            name="name"
                            value={this.props.values.name}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("name")}
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput
                            name="sender_name"
                            value={this.props.values.sender_name || this.props.componentConfig.config.default_email_name}
                            label="Küldő neve"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("sender_name")}
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            name="sender_email"
                            value={this.props.values.sender_email || this.props.componentConfig.config.default_email_address}
                            label="Küldő email címe"
                            disabled={true}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("sender_email")}
                        />
                    </div>
                    {/*<div className="col-md-4">
                        <Select
                            label="Csoport"
                            name="parent"
                            component={this.props.componentConfig.componentname}
                            objectValue={false}
                            labelKey="name"
                            storeType="remote"
                            isClearable={true}
                            value={this.props.values.parent}
                            {...this.props.getFieldProps("parent")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>*/}
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput
                            name="subject"
                            value={this.props.values.subject}
                            label="Tárgy"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("subject")}
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        {
                            this.state.isLoading !== 0 ?
                                <ContentLoader />
                            :
                                (
                                    this.props.values.template_engine !== "mjml"
                                    ?
                                    <TemplateEditor
                                        {...this.props.getFieldProps("html")}
                                        name="html"
                                        toolbar={toolbar}
                                        component={this.props.componentConfig.componentname}
                                        componentId={this.props.values[this.props.componentConfig.idfield]}
                                        images={this.props.values.images}
                                        value={this.props.values.html}
                                        label="Tartalom"
                                        height="400px"
                                        saveChanges={this.props.setFieldValue}
                                        {...this.props.getFieldProps("html")}
                                        disabled={disabled || this.props.isLoading}
                                    />
                                    :
                                    <MjmlField
                                        {...this.props.getFieldProps("html")}
                                        toolbar={[
                                            (p) => <EmailTemplateButton
                                                key={p.key}
                                                saveChanges={(template) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("html", template); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
                                                saveTemplateEngine={(template_engine) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("template_engine", template_engine); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
                                                saveReplacementEngine={(replacement_engine) => this.setState({isLoading: ++this.state.isLoading}, () => {this.props.setFieldValue("replacement_engine", replacement_engine); this.state.isLoading === 3 && this.setState({isLoading: 0})})}
                                            />
                                        ]}
                                        name="html"
                                        label="Tartalom"
                                        component={this.props.componentConfig.componentname}
                                        componentId={this.props.values[this.props.componentConfig.idfield]}
                                        saveChanges={this.props.setFieldValue}
                                        value={this.props.values.html}
                                        disabled={disabled || this.props.isLoading}
                                    />
                                )
                        }
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <DateTimeInput
                            name="send_scheduled_at"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                            label="Küldés dátuma"
                            isClearable={true}
                            value={this.props.values.send_scheduled_at}
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            label="Kampány"
                            name="campaign"
                            component="Campaign"
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            {...this.props.getFieldProps("campaign")}
                            value={this.props.values.campaign}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {
                    (this.props.newsletters || []).length > 1
                    &&
                    <Fragment>
                        <QueryBuilder {...paramsProps} />
                        <div className="row form-row">
                            <div className="col-md-6">
                                <TextInput
                                    label="Limit"
                                    value={recipient_params.limit}
                                    type="number"
                                    saveChanges={(field, value) => {
                                        const newFilter = JSON.parse(JSON.stringify(recipient_params));
                                        newFilter.limit = parseInt(value || "0");
                                        if (!newFilter.limit) {
                                            delete newFilter.limit;
                                        }
                                        if (Object.keys(newFilter).length) {
                                            this.props.setFieldValue("recipient_params", newFilter);
                                        } else {
                                            this.props.setFieldValue("recipient_params", null);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <Select
                                    optionname="NewsletterTargetOrder"
                                    storeType="local"
                                    isClearable={true}
                                    label="Kiválasztás/Sorrend"
                                    value={recipient_params.order}
                                    objectValue={false}
                                    saveChanges={(field, value) => {
                                        const newFilter = JSON.parse(JSON.stringify(recipient_params));
                                        newFilter.order = value;
                                        if (!newFilter.order) {
                                            delete newFilter.order;
                                        }
                                        if (Object.keys(newFilter).length) {
                                            this.props.setFieldValue("recipient_params", newFilter);
                                        } else {
                                            this.props.setFieldValue("recipient_params", null);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Fragment>
                }
                <NewsletterStat {...this.props} component_id={this.props.values[this.props.componentConfig.idfield]} component={this.props.componentConfig.componentname} />
            </form>
        );
    }
}

export default createForm(NewsletterForm);
